import React from "react";

import logoGreen from "../assets/svgs/adoptzi_logo.svg";
import LoadingWrapper from "./LoadingWrapper";
import backgroundFigure from "../assets/svgs/background_figure.svg";

/**
 *
 * @param props
 * Properties:
 */
function Loading(props) {
  return (
    <LoadingWrapper>
      <img
        className={
          "background-image-abstract background-image-abstract--right-top"
        }
        src={backgroundFigure}
        alt={"Imagen de fondo"}
      />
      <img
        className={
          "background-image-abstract background-image-abstract--left-bottom"
        }
        src={backgroundFigure}
        alt={"Imagen de fondo"}
      />
      <div className="loading d-flex align-items-center justify-content-center">
        <img src={logoGreen} alt={"Logo de Adoptzi"} />
        <div className="meter">
          <span>
            <span className="progress"></span>
          </span>
        </div>
      </div>
    </LoadingWrapper>
  );
}

export default Loading;
